// UI strings for the be.found.as editor, keyed by the English source string.
// Missing keys fall back to English.
const de: Record<string, string> = {
  "+ Add cover photo": "+ Titelbild hinzufügen",
  "1 Rue de Rivoli, Paris": "Unter den Linden 1, Berlin",
  "A bare domain can't use a CNAME, so it takes two steps. First, if your DNS provider offers an ALIAS or ANAME record (or CNAME flattening), point {domain} at this name — we keep it aimed at our servers, so it never needs updating:":
    "Eine nackte Domain kann kein CNAME verwenden, daher braucht es zwei Schritte. Falls Ihr DNS-Anbieter ALIAS- oder ANAME-Einträge (oder CNAME-Flattening) anbietet, richten Sie {domain} zuerst auf diesen Namen — wir halten ihn auf unsere Server gerichtet, er muss also nie aktualisiert werden:",
  "A domain you own can show this page. Your found.as address keeps working — the domain is an extra way in, and you can remove it anytime.":
    "Eine eigene Domain kann diese Seite anzeigen. Ihre found.as-Adresse funktioniert weiter — die Domain ist ein zusätzlicher Zugang und lässt sich jederzeit entfernen.",
  "A line or two of text": "Ein oder zwei Zeilen Text",
  Accent: "Akzent",
  "Accent color — left/right arrows change the hue, up/down how colorful":
    "Akzentfarbe — Pfeile links/rechts ändern den Farbton, hoch/runter die Farbigkeit",
  Access: "Zugang",
  "Add a name, photo, description, or link.":
    "Fügen Sie einen Namen, ein Foto, eine Beschreibung oder einen Link hinzu.",
  "Add a video link.": "Fügen Sie einen Video-Link hinzu.",
  "Add an image": "Bild hinzufügen",
  "Add photo": "Foto hinzufügen",
  "Add row": "Zeile hinzufügen",
  "Add to your page": "Zur Seite hinzufügen",
  Address: "Adresse",
  Advanced: "Erweitert",
  "Advanced format": "Erweitertes Format",
  "Allow access": "Zugriff erlauben",
  "Allow pop-ups to open the print page.":
    "Erlauben Sie Pop-ups, um die Druckseite zu öffnen.",
  "Any family from the {catalog}. Google is never involved.":
    "Jede Schriftfamilie aus dem {catalog}. Google ist nie beteiligt.",
  Authorize: "Autorisieren",
  Auto: "Automatisch",
  "Auto follows each visitor's device":
    "Automatisch folgt dem Gerät jedes Besuchers",
  "Auto follows each visitor's device — check both looks here":
    "Automatisch folgt dem Gerät jedes Besuchers — prüfen Sie hier beide Ansichten",
  "Automatic preview image": "Automatisches Vorschaubild",
  Background: "Hintergrund",
  "Blank password — anyone who opens this editor address can change your page.":
    "Leeres Passwort — jeder, der diese Editor-Adresse öffnet, kann Ihre Seite ändern.",
  "Blur behind": "Dahinter weichzeichnen",
  "Button text": "Button-Text",
  "Button transparency": "Button-Transparenz",
  "Can't sign in": "Anmeldung nicht möglich",
  Cancel: "Abbrechen",
  Canvas: "Hintergrund",
  "Cards & poster": "Karten & Poster",
  "Change address": "Adresse ändern",
  "Change password": "Passwort ändern",
  "Check now": "Jetzt prüfen",
  "Checking availability…": "Verfügbarkeit wird geprüft…",
  "Checking this sign-in request…": "Anmeldeanfrage wird geprüft…",
  "Choose a file under 5MB.": "Wählen Sie eine Datei unter 5 MB.",
  Circle: "Kreis",
  Close: "Schließen",
  Colors: "Farben",
  Connect: "Verbinden",
  Contact: "Kontakt",
  "Contact buttons": "Kontakt-Buttons",
  "Contact card": "Kontaktkarte",
  "Contact page": "Kontaktseite",
  "Contact page editor": "Kontaktseiten-Editor",
  Content: "Inhalt",
  Continue: "Weiter",
  "Continue as {identity}": "Weiter als {identity}",
  "Copied as plain text": "Als reiner Text kopiert",
  "Copied ✓": "Kopiert ✓",
  Copy: "Kopieren",
  "Copy link": "Link kopieren",
  "Copy plain text": "Reinen Text kopieren",
  "Copy signature": "Signatur kopieren",
  "Copy {type} value": "{type}-Wert kopieren",
  "Copy, then paste into your email app's signature settings.":
    "Kopieren, dann in die Signatur-Einstellungen Ihres E-Mail-Programms einfügen.",
  Corners: "Ecken",
  "Could not compress that image.": "Das Bild konnte nicht komprimiert werden.",
  "Could not prepare the icon.": "Das Icon konnte nicht vorbereitet werden.",
  "Could not prepare the image.": "Das Bild konnte nicht vorbereitet werden.",
  "Could not read that icon.": "Das Icon konnte nicht gelesen werden.",
  "Could not read that image.": "Das Bild konnte nicht gelesen werden.",
  "Could not read the image.": "Das Bild konnte nicht gelesen werden.",
  "Couldn't render the social preview image — publishing the page without it.":
    "Das Social-Vorschaubild konnte nicht erzeugt werden — die Seite wird ohne veröffentlicht.",
  Cover: "Titelbild",
  "Choose a password": "Wählen Sie ein Passwort",
  "Create page": "Seite erstellen",
  "Cropped to 1200×630 and served with your page. Until you add one, links share without an image.":
    "Auf 1200×630 zugeschnitten und mit Ihrer Seite ausgeliefert. Bis Sie eines hinzufügen, werden Links ohne Bild geteilt.",
  "Custom link": "Eigener Link",
  "Custom preview image": "Eigenes Vorschaubild",
  "Custom preview image that will be published":
    "Eigenes Vorschaubild, das veröffentlicht wird",
  Dark: "Dunkel",
  "Darken by": "Abdunkeln um",
  "Delete page": "Seite löschen",
  "Delete permanently": "Endgültig löschen",
  "Design sections": "Design-Bereiche",
  "Domain you own": "Eigene Domain",
  Dots: "Punkte",
  "Drag to reorder": "Zum Umsortieren ziehen",
  "Drag to resize the preview": "Ziehen, um die Vorschaugröße zu ändern",
  "Edit page": "Seite bearbeiten",
  Email: "E-Mail",
  "Email signature": "E-Mail-Signatur",
  "Emoji icon": "Emoji-Icon",
  "Enter a Bluesky handle or link.":
    "Geben Sie einen Bluesky-Handle oder -Link ein.",
  "Enter a Bluesky handle.": "Geben Sie einen Bluesky-Handle ein.",
  "Enter a Cash App cashtag or link.":
    "Geben Sie einen Cash-App-Cashtag oder -Link ein.",
  "Enter a Cash App cashtag.": "Geben Sie einen Cash-App-Cashtag ein.",
  "Enter a Mastodon address or link.":
    "Geben Sie eine Mastodon-Adresse oder einen Link ein.",
  "Enter a Matrix ID or link.": "Geben Sie eine Matrix-ID oder einen Link ein.",
  "Enter a Substack name or link.":
    "Geben Sie einen Substack-Namen oder -Link ein.",
  "Enter a WhatsApp phone number.":
    "Geben Sie eine WhatsApp-Telefonnummer ein.",
  "Enter a YouTube, Vimeo, or PeerTube link.":
    "Geben Sie einen YouTube-, Vimeo- oder PeerTube-Link ein.",
  "Enter a domain like yourname.com.":
    "Geben Sie eine Domain wie ihrname.com ein.",
  "Enter a phone number.": "Geben Sie eine Telefonnummer ein.",
  "Enter a redirect destination before publishing.":
    "Geben Sie vor dem Veröffentlichen ein Weiterleitungsziel ein.",
  "Enter a valid Bluesky link.": "Geben Sie einen gültigen Bluesky-Link ein.",
  "Enter a valid Cash App link.": "Geben Sie einen gültigen Cash-App-Link ein.",
  "Enter a valid Mastodon link.": "Geben Sie einen gültigen Mastodon-Link ein.",
  "Enter a valid Matrix link.": "Geben Sie einen gültigen Matrix-Link ein.",
  "Enter a valid Substack link.": "Geben Sie einen gültigen Substack-Link ein.",
  "Enter a valid email address.": "Geben Sie eine gültige E-Mail-Adresse ein.",
  "Enter a valid map link.": "Geben Sie einen gültigen Karten-Link ein.",
  "Enter a valid redirect destination before publishing.":
    "Geben Sie vor dem Veröffentlichen ein gültiges Weiterleitungsziel ein.",
  "Enter a valid web address.": "Geben Sie eine gültige Webadresse ein.",
  "Enter a valid {label} link.": "Geben Sie einen gültigen {label}-Link ein.",
  "Enter a valid {service} link.":
    "Geben Sie einen gültigen {service}-Link ein.",
  "Enter a {label} link.": "Geben Sie einen {label}-Link ein.",
  "Enter a {service} username or link.":
    "Geben Sie einen {service}-Benutzernamen oder -Link ein.",
  "Enter a {service} username.": "Geben Sie einen {service}-Benutzernamen ein.",
  "Enter an Instagram username or link.":
    "Geben Sie einen Instagram-Benutzernamen oder -Link ein.",
  "Enter an address or map link.":
    "Geben Sie eine Adresse oder einen Karten-Link ein.",
  "Enter an email address.": "Geben Sie eine E-Mail-Adresse ein.",
  "Enter an https:// {label} link.":
    "Geben Sie einen {label}-Link mit https:// ein.",
  "Enter the existing password": "Geben Sie das bestehende Passwort ein",
  "Export backup (.zip)": "Backup exportieren (.zip)",
  Fallback: "Ersatzschrift",
  "Favicon emoji": "Favicon-Emoji",
  "Feature this link": "Diesen Link hervorheben",
  Featured: "Hervorgehoben",
  "Featured — hidden until complete.":
    "Hervorgehoben — ausgeblendet, bis alles ausgefüllt ist.",
  File: "Datei",
  "File to publish": "Zu veröffentlichende Datei",
  Fill: "Füllen",
  Filled: "Gefüllt",
  "Finish the Instagram link or username.":
    "Vervollständigen Sie den Instagram-Link oder Benutzernamen.",
  "Finish the {label} link.": "Vervollständigen Sie den {label}-Link.",
  "Fit whole image": "Ganzes Bild zeigen",
  Font: "Schrift",
  Forget: "Vergessen",
  "Forget on this device": "Auf diesem Gerät vergessen",
  "Format the text": "Text formatieren",
  "Found it! Securing {domain} — this usually takes under a minute…":
    "Gefunden! {domain} wird gesichert — das dauert meist unter einer Minute…",
  "Google Fonts catalog ↗": "Google-Fonts-Katalog ↗",
  "Google review": "Google-Rezension",
  Gradient: "Verlauf",
  Grid: "Raster",
  "HTML content": "HTML-Inhalt",
  Heading: "Überschrift",
  Height: "Höhe",
  "Hidden until complete.": "Ausgeblendet, bis alles ausgefüllt ist.",
  "Hidden until it has text.": "Ausgeblendet, bis Text vorhanden ist.",
  "Hidden.": "Ausgeblendet.",
  Hide: "Ausblenden",
  "Host one file up to 5MB.": "Hosten Sie eine Datei bis 5 MB.",
  "Icon lookup failed ({status}).": "Icon-Suche fehlgeschlagen ({status}).",
  "Icon saved into your page.": "Icon in Ihrer Seite gespeichert.",
  Image: "Bild",
  "Import backup": "Backup importieren",
  "Import icon": "Icon importieren",
  "Imported — review and publish to make it live.":
    "Importiert — prüfen und veröffentlichen, um es live zu schalten.",
  "Importing…": "Wird importiert…",
  "In your Google Business Profile, use “Ask for reviews” to copy your review link — it looks like":
    "Nutzen Sie in Ihrem Google-Unternehmensprofil „Um Rezensionen bitten“, um Ihren Rezensionslink zu kopieren — er sieht aus wie",
  "Include on business cards": "Auf Visitenkarten aufnehmen",
  Language: "Sprache",
  "Lets visitors download a contact card (.vcf). It appears once the page has a name and a shown phone or email.":
    "Besucher können eine Kontaktkarte (.vcf) herunterladen. Sie erscheint, sobald die Seite einen Namen und eine angezeigte Telefonnummer oder E-Mail hat.",
  Light: "Hell",
  "Lighten by": "Aufhellen um",
  "Links for web, email, social, phone, and more.":
    "Links für Web, E-Mail, Social Media, Telefon und mehr.",
  "Loading…": "Wird geladen…",
  Looks: "Aussehen",
  "Lowercase letters, numbers and hyphens make the best address — capitals and special characters are harder to type and share.":
    "Kleinbuchstaben, Zahlen und Bindestriche ergeben die beste Adresse — Großbuchstaben und Sonderzeichen sind schwerer zu tippen und zu teilen.",
  "Main address": "Hauptadresse",
  "Manage domains": "Domains verwalten",
  "Markdown content": "Markdown-Inhalt",
  "Markdown: {bold}, {italic}, links, lists and headings.":
    "Markdown: {bold}, {italic}, Links, Listen und Überschriften.",
  "Mathematician · first computer programmer":
    "Mathematikerin · erste Programmiererin",
  Menu: "Menü",
  "Move page": "Seite umziehen",
  "Move {label} down": "{label} nach unten verschieben",
  "Move {label} up": "{label} nach oben verschieben",
  "Need a public email address? Create a forwarding alias at":
    "Sie brauchen eine öffentliche E-Mail-Adresse? Erstellen Sie einen Weiterleitungs-Alias bei",
  "New address": "Neue Adresse",
  "New page path": "Neuer Seitenpfad",
  "New password": "Neues Passwort",
  "No ALIAS support? Use a subdomain like {www} instead — it takes a plain CNAME.":
    "Kein ALIAS möglich? Nutzen Sie stattdessen eine Subdomain wie {www} — sie braucht nur einen einfachen CNAME.",
  "No contact buttons yet.": "Noch keine Kontakt-Buttons.",
  "No icon found for that site.": "Kein Icon für diese Website gefunden.",
  "No priv.cbor found in this file.":
    "Kein priv.cbor in dieser Datei gefunden.",
  None: "Ohne",
  "Not a ZIP file.": "Keine ZIP-Datei.",
  "Now at found.as/{target}.": "Jetzt unter found.as/{target}.",
  "On a subdomain instead (like www.{domain})?":
    "Lieber auf einer Subdomain (wie www.{domain})?",
  "One CNAME on {domain} pointing to the address above. It connects the domain and proves it's yours in a single record.":
    "Ein CNAME auf {domain}, der auf die obige Adresse zeigt. Er verbindet die Domain und beweist mit einem einzigen Eintrag, dass sie Ihnen gehört.",
  "Online in seconds": "Online in Sekunden",
  Open: "Öffnen",
  "Open your public page": "Ihre öffentliche Seite öffnen",
  "Optional line under the button": "Optionale Zeile unter dem Button",
  "Or upload a separate dark image":
    "Oder ein separates dunkles Bild hochladen",
  Outline: "Kontur",
  "Page link": "Seitenlink",
  "Page password": "Seiten-Passwort",
  "Page path": "Seitenpfad",
  "Page preview": "Seitenvorschau",
  "Page type": "Seitentyp",
  "Password changed — save a fresh recovery kit.":
    "Passwort geändert — speichern Sie ein neues Wiederherstellungskit.",
  "Paste a valid Google review link.":
    "Fügen Sie einen gültigen Google-Rezensionslink ein.",
  "Paste your Google review link.":
    "Fügen Sie Ihren Google-Rezensionslink ein.",
  Phone: "Telefon",
  "Photo shape": "Fotoform",
  "Pick an address and a password. No account, no cookies.":
    "Wählen Sie eine Adresse und ein Passwort. Kein Konto, keine Cookies.",
  Pill: "Pillenform",
  Platforms: "Plattformen",
  "Preparing…": "Wird vorbereitet…",
  Preview: "Vorschau",
  "Preview appearance": "Vorschau-Darstellung",
  "Preview description": "Vorschau-Beschreibung",
  "Preview fallback": "Vorschau-Fallback",
  "Preview image appearance": "Vorschaubild-Darstellung",
  "Preview image that will be published":
    "Vorschaubild, das veröffentlicht wird",
  "Preview title": "Vorschau-Titel",
  "Profile email": "Profil-E-Mail",
  Publish: "Veröffentlichen",
  "Publish a custom HTML page.": "Veröffentlichen Sie eine eigene HTML-Seite.",
  "Publish to {host}": "Auf {host} veröffentlichen",
  "QR code type": "QR-Code-Typ",
  Redirect: "Weiterleitung",
  "Redirect destination": "Weiterleitungsziel",
  "Redirect, markdown page, HTML page, or file.":
    "Weiterleitung, Markdown-Seite, HTML-Seite oder Datei.",
  "Refresh icon": "Icon aktualisieren",
  "Remember on this device": "Auf diesem Gerät merken",
  "Remembered on this device": "Auf diesem Gerät gemerkt",
  Remove: "Entfernen",
  "Remove dark image": "Dunkles Bild entfernen",
  "Remove icon": "Icon entfernen",
  "Remove {label}": "{label} entfernen",
  Replace: "Ersetzen",
  "Replace dark image": "Dunkles Bild ersetzen",
  "Replace image": "Bild ersetzen",
  Rounded: "Abgerundet",
  "Rounded square": "Abgerundetes Quadrat",
  Save: "Speichern",
  "Save QR": "QR speichern",
  "Save QR code": "QR-Code speichern",
  "Save contact": "Kontakt speichern",
  "Save contact button label": "Beschriftung des „Kontakt speichern“-Buttons",
  "Save recovery kit": "Wiederherstellungskit speichern",
  "Saves this page's key in this browser so future sign-ins skip the password. Only on a device you trust.":
    "Speichert den Schlüssel dieser Seite in diesem Browser, sodass künftige Anmeldungen ohne Passwort auskommen. Nur auf einem vertrauenswürdigen Gerät.",
  "Saves this page's key in this browser so it opens without the password. Only on a device you trust.":
    "Speichert den Schlüssel dieser Seite in diesem Browser, sodass sie sich ohne Passwort öffnet. Nur auf einem vertrauenswürdigen Gerät.",
  "Search fonts…": "Schriften suchen…",
  "Section header": "Abschnittsüberschrift",
  "Send visitors to one web address.":
    "Leiten Sie Besucher auf eine Webadresse.",
  Share: "Teilen",
  Sharing: "Teilen",
  Sharp: "Eckig",
  "Short description": "Kurzbeschreibung",
  Show: "Anzeigen",
  "Show an icon on this button — type an emoji, or import the site's icon. It's fetched once and saved into your page.":
    "Zeigen Sie ein Icon auf diesem Button — tippen Sie ein Emoji oder importieren Sie das Icon der Website. Es wird einmal abgerufen und in Ihrer Seite gespeichert.",
  "Show an icon on this button — type any emoji.":
    "Zeigen Sie ein Icon auf diesem Button — tippen Sie ein beliebiges Emoji.",
  "Show on page": "Auf der Seite anzeigen",
  "Shown as a heading.": "Wird als Überschrift angezeigt.",
  "Shown as a video.": "Wird als Video angezeigt.",
  "Shown as text.": "Wird als Text angezeigt.",
  "Shown in the browser tab.": "Wird im Browser-Tab angezeigt.",
  "Sign in": "Anmelden",
  "Sign in wherever you manage {domain}'s DNS — usually where you bought it — and add a CNAME record:":
    "Melden Sie sich dort an, wo Sie das DNS von {domain} verwalten — meist dort, wo Sie die Domain gekauft haben — und fügen Sie einen CNAME-Eintrag hinzu:",
  "Sign-in": "Anmeldung",
  "Signature preview": "Signatur-Vorschau",
  "Signing in…": "Anmeldung läuft…",
  Soft: "Sanft",
  "Start writing GitHub-flavored markdown.\n\nOptional front matter:\n---\ntitle: Page title\n---":
    "Beginnen Sie mit GitHub-flavored Markdown.\n\nOptionales Front Matter:\n---\ntitle: Seitentitel\n---",
  "Start writing HTML": "Beginnen Sie mit HTML",
  "Status line": "Statuszeile",
  Style: "Stil",
  Subtitle: "Untertitel",
  "TXT record": "TXT-Eintrag",
  "That file is over 5MB. Choose a smaller file.":
    "Diese Datei ist über 5 MB groß. Wählen Sie eine kleinere Datei.",
  "That icon is too large.": "Dieses Icon ist zu groß.",
  "That password doesn't match this page.":
    "Dieses Passwort passt nicht zu dieser Seite.",
  "That site did not return an icon.": "Diese Website hat kein Icon geliefert.",
  "The address featured on your QR code, printables and email signature. Your page stays reachable at every address either way.":
    "Die Adresse auf Ihrem QR-Code, Ihren Druckvorlagen und Ihrer E-Mail-Signatur. Ihre Seite bleibt in jedem Fall unter jeder Adresse erreichbar.",
  "Theme default": "Theme-Standard",
  "Then add this record so we know the domain is yours:":
    "Fügen Sie dann diesen Eintrag hinzu, damit wir wissen, dass die Domain Ihnen gehört:",
  "There is no password reset. Once you're in, save the recovery kit from the menu — it keeps your address and password somewhere safe.":
    "Es gibt kein Zurücksetzen des Passworts. Sobald Sie drin sind, speichern Sie das Wiederherstellungskit aus dem Menü — es bewahrt Adresse und Passwort sicher auf.",
  "This address already exists — password unlocked. Continue to edit it.":
    "Diese Adresse existiert bereits — Passwort entsperrt. Fahren Sie fort, um sie zu bearbeiten.",
  "This address exists. Enter its password to edit, or pick another address.":
    "Diese Adresse existiert. Geben Sie ihr Passwort ein, um sie zu bearbeiten, oder wählen Sie eine andere Adresse.",
  "This address isn't a found.as page.":
    "Diese Adresse ist keine found.as-Seite.",
  "This domain is already connected to another page.":
    "Diese Domain ist bereits mit einer anderen Seite verbunden.",
  "This is really me": "Das bin wirklich ich",
  "This permanently removes found.as/{path} and releases any custom domains. There's no undo.":
    "Das entfernt found.as/{path} endgültig und gibt alle eigenen Domains frei. Es gibt kein Zurück.",
  "This replaces your page's key, so any recovery kit you've saved stops working — save a fresh one afterwards.":
    "Das ersetzt den Schlüssel Ihrer Seite — jedes gespeicherte Wiederherstellungskit wird ungültig. Speichern Sie danach ein neues.",
  "This sign-in request is missing required details.":
    "Dieser Anmeldeanfrage fehlen erforderliche Angaben.",
  "This sign-in request isn't supported.":
    "Diese Anmeldeanfrage wird nicht unterstützt.",
  "Type {path} to confirm": "Tippen Sie {path} zur Bestätigung",
  "Update password": "Passwort aktualisieren",
  "Upload an image": "Bild hochladen",
  "Use @you:server.org, or paste a matrix.to link.":
    "Nutzen Sie @you:server.org oder fügen Sie einen matrix.to-Link ein.",
  "Use @you@server, or paste your profile link.":
    "Nutzen Sie @you@server oder fügen Sie Ihren Profil-Link ein.",
  "Use the cover as the page's name": "Titelbild als Seitennamen verwenden",
  "Use this to edit later": "Hiermit später bearbeiten",
  "Using a bare domain like example.com?":
    "Sie nutzen eine nackte Domain wie example.com?",
  "Video link": "Video-Link",
  "We check every few seconds — you can close this window and come back later.":
    "Wir prüfen alle paar Sekunden — Sie können dieses Fenster schließen und später wiederkommen.",
  "We couldn't secure {domain} after repeated attempts. Remove it, check your DNS records, and try again.":
    "Wir konnten {domain} trotz mehrerer Versuche nicht sichern. Entfernen Sie die Domain, prüfen Sie Ihre DNS-Einträge und versuchen Sie es erneut.",
  "Which address an app receives when someone signs in with your page and allows the email permission.":
    "Welche Adresse eine App erhält, wenn sich jemand mit Ihrer Seite anmeldet und die E-Mail-Berechtigung erlaubt.",
  Work: "Arbeit",
  "Working…": "Einen Moment…",
  "Works offline": "Funktioniert offline",
  "Write a simple page with Markdown.":
    "Schreiben Sie eine einfache Seite mit Markdown.",
  "You're live 🎉": "Sie sind live 🎉",
  "Your HTML page is live.": "Ihre HTML-Seite ist live.",
  "Your address": "Ihre Adresse",
  "Your contact page is live.": "Ihre Kontaktseite ist live.",
  "Your file is live.": "Ihre Datei ist live.",
  "Your markdown page is live.": "Ihre Markdown-Seite ist live.",
  "Your page moves to the new address. The old one stops working, and any custom domains follow automatically.":
    "Ihre Seite zieht auf die neue Adresse um. Die alte funktioniert nicht mehr, und eigene Domains folgen automatisch.",
  "Your page password": "Ihr Seiten-Passwort",
  "Your password never leaves this device — it only signs the approval.":
    "Ihr Passwort verlässt dieses Gerät nie — es signiert nur die Freigabe.",
  "Your redirect is live.": "Ihre Weiterleitung ist live.",
  crimson: "karmesinrot",
  "e.g. New": "z. B. Neu",
  "e.g. ☕": "z. B. ☕",
  forest: "waldgrün",
  "found.as home — switch to another page":
    "found.as-Startseite — zu einer anderen Seite wechseln",
  "found.as/{path} is available.": "found.as/{path} ist verfügbar.",
  graphite: "graphit",
  "hue {hue}°, {pct}% colorful": "Farbton {hue}°, {pct}% farbig",
  "needs attention": "braucht Aufmerksamkeit",
  ocean: "ozeanblau",
  rust: "rostrot",
  "securing…": "wird gesichert…",
  "theme default": "Theme-Standard",
  violet: "violett",
  "youtube.com, vimeo.com, or a PeerTube link":
    "youtube.com, vimeo.com oder ein PeerTube-Link",
  "{client} wants to access your found.as page with these permissions:":
    "{client} möchte mit diesen Berechtigungen auf Ihre found.as-Seite zugreifen:",
  "{client} wants to confirm you own this found.as page.":
    "{client} möchte bestätigen, dass diese found.as-Seite Ihnen gehört.",
  "{domain} isn't connected yet.": "{domain} ist noch nicht verbunden.",
  "{index} of {total}": "{index} von {total}",
  "{link} is live.": "{link} ist live.",
  "{name} is ready to publish.": "{name} ist bereit zur Veröffentlichung.",
  "▶ Add a video": "▶ Video hinzufügen",
  "✓ We can see your proof record — now waiting for {domain} to route to us, usually just the DNS change spreading.":
    "✓ Wir sehen Ihren Nachweis-Eintrag — jetzt warten wir, bis {domain} zu uns routet; meist muss sich nur die DNS-Änderung verbreiten.",
  "✓ {domain} is reaching us. Now add the record that proves it's yours — the {record} below.":
    "✓ {domain} erreicht uns. Fügen Sie jetzt den Eintrag hinzu, der beweist, dass sie Ihnen gehört — den {record} unten.",
};

export default de;
